// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "电力系统分析",
      "tec": "王欢",
      "week": "1-15,18周",
      "add": "教学楼A座220电力"
    },
    {
      "sub": "自动控制原理",
      "tec": "王祥凤",
      "week": "2,4,6,8,10,12-15周",
      "add": "教学楼A座220电力"
    },
    0,
    0,
    0
  ],
  "2": [
    {
      "sub": "电力电子技术",
      "tec": "李嘉欣",
      "week": "1-15周",
      "add": "教学楼A座220电力"
    },
    0,
    0,
    0,
    {
      "sub": "就业创业指导",
      "tec": "赵毅王刚王祎雪刘东岩",
      "week": "9-12周",
      "add": "大活礼堂"
    }
  ],
  "3": [
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "徐凤莉",
        "week": "1-8周",
        "add": "教学楼C座113教务"
      },
      {
        "sub": "国家安全教育",
        "tec": "徐凤莉",
        "week": "9-11,13周",
        "add": "教学楼C座113教务"
      }
    ],
    {
      "sub": "电力系统分析",
      "tec": "王欢",
      "week": "1-15,18周",
      "add": "教学楼A座320电力"
    },
    0,
    0,
    0
  ],
  "4": [
    0,
    {
      "sub": "自动控制原理",
      "tec": "王祥凤",
      "week": "1-15周",
      "add": "教学楼A座218电力"
    },
    0,
    {
      "sub": "工程伦理",
      "tec": "林雪金钰",
      "week": "1-8周",
      "add": "教学楼A座118电力"
    },
    0
  ],
  "5": [
    {
      "sub": "电力电子技术",
      "tec": "李嘉欣",
      "week": "7-15周",
      "add": "教学楼A座220电力"
    },
    [
      {
        "sub": "毛泽东思想和中国特色社会主义理论体系概论",
        "tec": "徐凤莉",
        "week": "1-8周",
        "add": "教学楼A座118电力"
      },
      {
        "sub": "国家安全教育",
        "tec": "徐凤莉",
        "week": "9-11,13周",
        "add": "教学楼A座118电力"
      }
    ],
    {
      "sub": "电力系统分析",
      "tec": "王欢",
      "week": "2,4,6,8,10,12,14,18周",
      "add": "教学楼A座218电力"
    },
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
